import { API_BASE } from 'utils';
import makeHttpAction from '../../../oldpantheon/redux/creators/actions/makeHttpAction';

const getHoroscope = makeHttpAction({
  model: `horoscope`,
  method: `get`,
  baseUrl: API_BASE,
  verb: `get`,
});

export default {
  getHoroscope,
};
